module.exports = {"institutions_search_bar":{"type_institution":["Type d’activités culturelles","Type of cultural activities"],"select_institution":["Institution","Institution"],"age":["Âge","Age"],"item_all":["Tous","All"],"trouver_institution":["Trouvez une institution","Find an institution"],"button_search_title":["Rechercher","Search"],"button_search_title_mobile":["Trouver une institution","Find an institution"]}}


//////////////////
// WEBPACK FOOTER
// ./src/features/Institutions/translations/translations_institutionssearchbar.json
// module id = 1890
// module chunks = 0